module.exports = __webpack_public_path__ + "static/media/LogicLever1_2_2.9479ebb7.png";